import { render, staticRenderFns } from "./MoebelCarousel.vue?vue&type=template&id=657683fb"
import script from "./MoebelCarousel.vue?vue&type=script&lang=js"
export * from "./MoebelCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports